module.exports = __webpack_public_path__ + "static/media/belveb-small.a76291b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belveb-small.png
// module id = 498
// module chunks = 0